export default "__VITE_PUBLIC_ASSET__e2f01894__"